/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllSourceContactsResponse } from './FindAllSourceContactsResponse';
import {
    FindAllSourceContactsResponseFromJSON,
    FindAllSourceContactsResponseFromJSONTyped,
    FindAllSourceContactsResponseToJSON,
    FindAllSourceContactsResponseToJSONTyped,
} from './FindAllSourceContactsResponse';

/**
 * 
 * @export
 * @interface FindAllSourceContacts200Response
 */
export interface FindAllSourceContacts200Response {
    /**
     * 
     */
    data?: FindAllSourceContactsResponse;
}

/**
 * Check if a given object implements the FindAllSourceContacts200Response interface.
 */
export function instanceOfFindAllSourceContacts200Response(value: object): value is FindAllSourceContacts200Response {
    return true;
}

export function FindAllSourceContacts200ResponseFromJSON(json: any): FindAllSourceContacts200Response {
    return FindAllSourceContacts200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceContacts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceContacts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllSourceContactsResponseFromJSON(json['data']),
    };
}

export function FindAllSourceContacts200ResponseToJSON(json: any): FindAllSourceContacts200Response {
    return FindAllSourceContacts200ResponseToJSONTyped(json, false);
}

export function FindAllSourceContacts200ResponseToJSONTyped(value?: FindAllSourceContacts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllSourceContactsResponseToJSON(value['data']),
    };
}

